import { isArray, isObjectLike } from 'lodash-es'
import qs from 'qs'

import { deleteNullField } from '@/utils/common'

// null 인 값은 서버로 보내지 않고, 배열은 쉼표로 잇는다. 단 Spring 정렬은 `속성,방향` 한 쌍이 sort 값 하나라
// 여러 정렬을 쉼표로 이으면 방향이 속성으로 읽히므로 sort 만 키를 반복해 싣는다.
export const serializeParams = (params: unknown) => {
  const newParams = isObjectLike(params) ? deleteNullField(params as object) : params
  if (isObjectLike(newParams) && isArray((newParams as { sort?: unknown }).sort)) {
    const { sort, ...rest } = newParams as { sort: string[] }
    return [
      qs.stringify(rest, { arrayFormat: 'comma' }),
      qs.stringify({ sort }, { arrayFormat: 'repeat' }),
    ]
      .filter(Boolean)
      .join('&')
  }
  return qs.stringify(newParams, { arrayFormat: 'comma' })
}
